module.exports = __webpack_public_path__ + "img/Framebell.f9c748d8.svg";